import React from 'react';
import moment from 'moment';
import { cellFlags, columnsFor, formatAmount, isIntlFormat, mismatchLabel } from './beneficiaryValidationHelpers';

// Hidden on screen; shown by the print stylesheet in beneficiaryValidation.css.
// Mismatches are marked with a symbol and bold text so the page reads in black and white.
const PrintView = ({ bankFormat, validateBy, validatedOn, rows, totals, highlightAmount, isFiltered }) => {
  const columns = columnsFor(bankFormat);
  const intl = isIntlFormat(bankFormat);
  const amountIndex = (field) => columns.findIndex((c) => c.field === field);

  return (
    <div className="bv-print-view">
      <h4>Beneficiary List Validation</h4>
      <div className="bv-print-meta">
        <div>Bank Format: {bankFormat}</div>
        <div>Validated By: {validateBy || '-'}</div>
        <div>Validated On: {validatedOn ? moment(validatedOn).format('DD-MMM-YYYY HH:mm') : '-'}</div>
        <div>Legend: ⚠ = mismatch, ✖ = no matching unit</div>
      </div>
      <table className="bv-print-table">
        <thead>
          <tr>
            <th>Mismatch</th>
            {columns.map((c) => (
              <th key={c.field}>{c.headerName}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => {
            const flagged = cellFlags(row, highlightAmount);
            return (
              <tr key={`${row.rowNo}-${i}`}>
                <td>
                  {row.isUnitNotFound ? '✖ ' : flagged.length || row.hasMismatch ? '⚠ ' : ''}
                  {mismatchLabel(row)}
                </td>
                {columns.map((c) => {
                  const isFlagged = flagged.includes(c.field);
                  const value = c.isAmount ? formatAmount(row[c.field]) : row[c.field];
                  return (
                    <td key={c.field} className={`${c.isAmount ? 'bv-amount' : ''} ${isFlagged ? 'bv-print-mismatch' : ''}`}>
                      {isFlagged ? '⚠ ' : ''}
                      {value}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
        {!intl && totals ? (
          <tfoot>
            <tr className="bv-print-total">
              <td colSpan={1 + amountIndex('systemAmount')}>{isFiltered ? 'Total (all rows)' : 'Total'}</td>
              <td className="bv-amount">{formatAmount(totals.totalSystemAmount)}</td>
              <td colSpan={amountIndex('bankAmount') - amountIndex('systemAmount') - 1} />
              <td className="bv-amount">{formatAmount(totals.totalBankAmount)}</td>
            </tr>
            <tr className="bv-print-total">
              <td colSpan={1 + amountIndex('bankAmount')}>Difference</td>
              <td className="bv-amount">{formatAmount(totals.difference) || '0.000'}</td>
            </tr>
          </tfoot>
        ) : null}
      </table>
    </div>
  );
};

export default PrintView;
